import { Vector3, Euler, Quaternion } from "three";

interface IServerPosition {
    x: number;
    y: number;
    z: number;
}

export function serverPositionToVector3({ x, y, z }: IServerPosition): Vector3 {
    return new Vector3(x, y, z);
}

interface IServerRotation {
    x: number;
    y: number;
    z: number;
}

export function serverRotationToEuler({ x, y, z }: IServerRotation): Euler {
    return new Euler(x, y, z, "XZY");
}

interface ISlerpRotation {
    rotation: Euler;
    targetRotation: Euler;
    lerper: number;
}

export function slerpRotation({
    rotation,
    targetRotation,
    lerper,
}: ISlerpRotation): Euler {
    const rotationQuarternion = new Quaternion();
    rotationQuarternion.setFromEuler(
        new Euler(rotation.x, rotation.y, rotation.z, "XYZ")
    );
    const targetQuarternion = new Quaternion();
    targetQuarternion.setFromEuler(
        new Euler(targetRotation.x, targetRotation.y, targetRotation.z, "XYZ")
    );

    const slerpedQuarternion = rotationQuarternion.slerp(
        targetQuarternion,
        lerper
    );

    return new Euler().setFromQuaternion(slerpedQuarternion);
}
